import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { DataService } from '../_services/data.service';
import { MatriculacionService } from '../_services/matriculacion.service';

@Component({
  selector: 'app-vista-qr',
  templateUrl: './vista-qr.component.html',
  styleUrls: ['./vista-qr.component.scss']
})
export class VistaQrComponent implements OnInit {
  resultado:any=null;
  hash!:string;
  error:boolean=false;
  constructor( private matriculacionService:MatriculacionService,
               private activatedRoute: ActivatedRoute,
               private dataService:DataService,
               private router: Router,
               private appComponent:AppComponent) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(paramsId => {
      this.hash = paramsId.id;
    });
    this.getDatos();
  }

  getDatos(){
    this.error=false;
    this.appComponent.spinnerGeneral=true;
    this.matriculacionService.infoQr(this.hash).subscribe(result=>{
      this.resultado=result;
      this.appComponent.spinnerGeneral=false;
    },(error)=>{
      this.dataService.errorProcesoNoExistente=error.error.apierror.message;
      this.router.navigate(['/validar-error']);
      this.error=true;
    });
  }

}
